import Image from 'next/image';

type DownloadIconProps = {
  alt?: string;
  className?: string;
};

export function DownloadIcon({ alt = 'Download', className = 'w-6 h-6' }: DownloadIconProps) {
  return (
    <Image
      src="/download.svg"
      alt={alt}
      width={24}
      height={24}
      className={className}
      unoptimized
    />
  );
}
